export type Pagination = {
  itemsPerPage: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  previousPage: number;
  currentPage: number;
  nextPage: number;
  lastPage: number;
  totalItems: number;
  loading: boolean;
};

export const defaultPagination: Pagination = {
  itemsPerPage: 12,
  hasPreviousPage: false,
  hasNextPage: false,
  previousPage: 0,
  currentPage: 1,
  nextPage: 1,
  lastPage: 1,
  totalItems: 0,
  loading: true
};
